import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import "../styles/navbar.css"
import { Link, useNavigate } from "react-router-dom";
import ProfileMenu from "../pages/ProfileMenu";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import Image from "./Image/Image";
import LoginModal from "./LoginModal";
import { loginSuccess } from "../store/authSlice";
import { fetchSiteConfig } from "../store/siteConfigSlice";

interface NavCategoryItem {
  title: string;
  url: string,
  items?: NavCategoryItem[];
}
const Navbar: React.FC = () => {
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const navigate = useNavigate();
  const [isLoginModalActive, setIsLoginModalActive] = useState(false);
  const { token, userName, triggerNavbarReload } = useSelector((state: RootState) => state.auth);

  //Use state to force re-render
  const [forceReload, setForceReload] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const config = useSelector((state: RootState) => state.siteConfig);

  useEffect(() => {
    // Load from localStorage if available
    const cachedConfig = localStorage.getItem('siteConfig');
    if (cachedConfig) {
      dispatch({ type: 'siteConfig/setSiteConfig', payload: JSON.parse(cachedConfig) });
    }

    // Fetch new config
    dispatch(fetchSiteConfig());
  }, [dispatch]);

  // Function to handle wishlist click
  const handleWishlistClick = () => {
    if (token) {
      navigate("accounts/wishlist"); // Redirect to wishlist if logged in
    } else {
      setIsLoginModalActive(true); // Open login modal if not logged in
    }
  };

  const handleLoginSuccess = (token: string, userName: string, loginid: string) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", userName);
    localStorage.setItem("loginid", loginid);

    dispatch(loginSuccess({ token, userName }));
    setIsLoginModalActive(false); // Close modal
    navigate("accounts/wishlist"); // Redirect to wishlist
  };

  useEffect(() => {
    setForceReload((prev) => !prev); //Trigger re-render on auth changes
  }, [triggerNavbarReload]);
  const categories: NavCategoryItem[] = config.menuItems;

  const toggleMobileMenu = () => {
    setIsMobileMenuActive(!isMobileMenuActive);
  };

  const handleNavigate = (url: string) => {
    toggleMobileMenu();
    navigate('products?collections='+url);
  }
  const toggleCategory = (title: string) => {
    setActiveCategory(activeCategory === title ? null : title);
  };

  return (
    <nav className="navbar has-background-white is-sticky-top">
      <div className="navbar-brand">
        <a
          role="button"
          className={`navbar-burger ${isMobileMenuActive ? 'is-active' : ''}`}
          aria-label="menu"
          aria-expanded="false"
          id="navbar-burger"
          onClick={toggleMobileMenu}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
        <Link className="navbar-item is-128x128 company-logo" to="/">
          <Image src={logo} alt="Product Logo" />
        </Link>
        <div className="navbar-item company-name">
          <h2>STRECH</h2>
          {/* <h2><Image src="/Images/Strech-logo.png" /></h2> */}
        </div>

        <a className="navbar-mobile-action is-hidden-desktop"><div className="navbar-item has-text-centered">
          <span className="material-icons"><Link to="cart">shopping_cart</Link></span>
        </div></a>
        <a className="navbar-mobile-action is-hidden-desktop"><ProfileMenu isLoggedIn={!!token} userName={userName ?? "User"} /></a>
      </div>
      <div className={`navbar-parent navbar-menu ${isMobileMenuActive ? 'is-active' : ''}`}>
        <div className="navbar-start">
          {categories.map((item) => (

            <div className="navbar-item has-dropdown is-hoverable is-hidden-mobile" key={item.title}>
              <span onClick={() => { handleNavigate(item.url) }} className="navbar-link is-arrowless" key={item.title}>
                {item.title}
              </span>
              <div className="navbar-dropdown">
                {item.items?.map((option) => (
                  <span onClick={() => { handleNavigate(option.url) }} className="navbar-item" key={option.title}>
                    {option.title}
                  </span>
                ))}
              </div>
            </div>
          ))}
          {/* Mobile View */}
          <div className="is-hidden-tablet">
            {categories.map((category) => (
              <div key={category.title} className="navbar-item">
                <div
                  className="is-flex is-justify-content-space-between is-align-items-center"
                  onClick={() => toggleCategory(category.title)}
                  style={{ cursor: 'pointer', width: '100%' }}
                >
                  <span>{category.title}</span>
                  {activeCategory === category.title ? <span className="material-symbols-outlined"> keyboard_arrow_up</span> : <span className="material-symbols-outlined"> keyboard_arrow_down</span>}

                </div>
                {activeCategory === category.title && (
                  <div className="menu-list pl-4 mt-2">
                    {category.items?.map((option) => (
                      <span onClick={() => { handleNavigate(option.url) }} className="navbar-item" key={option.title}>
                        {option.title}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div><div className="navbar-end search-box">
          {/* <SearchComponent></SearchComponent> */}
          {/* <div className="navbar-item has-text-centered">
            <input className="input-search-box" placeholder="Search for products, brands and more"></input>
          </div> */}

        </div>
        <div className="navbar-end">
          <div className="navbar-item has-text-centered">
            <span className="material-icons"><Link to="cart">shopping_cart</Link></span>
          </div>
          <div className="navbar-item has-text-centered" onClick={handleWishlistClick}>
            <span className="material-symbols-outlined">
              <span className="wishlist-icon" onClick={handleWishlistClick}>favorite</span>
            </span>

          </div>
          <div className="navbar-item has-text-centered">
            {/* <span className="material-icons">person</span> */}
            <ProfileMenu isLoggedIn={!!token} userName={userName ?? "User"} />
          </div>
        </div>

      </div>
      {/* Login Modal */}
      <LoginModal
        isActive={isLoginModalActive}
        toggleModal={() => setIsLoginModalActive(false)}
        onSuccess={handleLoginSuccess}
      />
    </nav>
  );
}
export default Navbar;
